import { render, staticRenderFns } from "./ModalUserResetPassword.vue?vue&type=template&id=8fbc628a&"
import script from "./ModalUserResetPassword.vue?vue&type=script&lang=js&"
export * from "./ModalUserResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports